import * as marietta from "../../..";
import { Dialog } from "../../../core/view";
import { CorrectionType, ModuleType } from "../../../LiDAR/commands/modifier/CorrectionManager";
import { ThreeView } from "../../../view3d/webcad";

export class CorrectionDialog extends Dialog {
    
    constructor(draggable: boolean) {
        super(draggable);
    }

    /**
     * HTML生成
     */
    buildContent() {
        
        const createText = (info: CorrectionType): string => {
            if (correctionManager.getLocalStrage(info.key) == null) {
                return '<td class="inputClass"><input type="number" id="' + info.key + '" value="' + info.defalt + '" min="' + info.min + '" max="' + info.max + '"></td>';
            } else {
                return '<td class="inputClass"><input type="number" id="' + info.key + '" value="' + correctionManager.getLocalStrage(info.key) + '" min="' + info.min + '" max="' + info.max + '"></td>';
            }
        }

        const createSelect = (info: CorrectionType): string => {
            const isDefalt = (i :number) => correctionManager.getLocalStrage(info.key) == null && info.option[i].select == true;
            const isLocalStorage = (i :number) => (correctionManager.getLocalStrage(info.key) != null && correctionManager.getLocalStrage(info.key) == info.option[i].num.toString());
            let contents = '<td class="selectClass"><select id="' + info.key + '">';
            for (let i = 0; i < (<ModuleType[]>info.option).length; i++) {
                if (isDefalt(i) || isLocalStorage(i)) {
                    contents += '<option value="' + info.option[i].num + '" id="radioSnapUnit' + i + '" selected>'+ info.option[i].str +'</option>';
                } else {
                    contents += '<option value="' + info.option[i].num + '" id="radioSnapUnit' + i + '">'+ info.option[i].str +'</option>';
                }
            }
            contents += '</select></td>';
            return contents;
        }

        let id: string | null, title: string | null, contents: string | null, footer: string | null;
        const correctionManager = ThreeView.get().correctionManager;

        //ダイアログのコンテンツ生成
        id = 'CorrectionDialog';

        switch (marietta.webcad.WebCADGlobal.language) {
            case "jp":
                title = '補正しきい値設定';
                break;
            default:
                title = 'Correction threshold setting';
                break;
        }
        
        contents = '<div class="CorrectionDialogBody">';
        contents += '<table>\n';
        contents += '<tbody>\n';
        contents += '<tr>\n';
        contents += '<th><span>直線化補正（頂点削除は行わない）</span></th>';
        contents += createText(correctionManager.Correction[1]);
        contents += '<td class="unit">mm</td>';
        contents += '</tr>\n';
        contents += '<tr>\n';
        contents += '<th><span>直線化補正（頂点削除を行う）</span></th>';
        contents += createText(correctionManager.Correction[11]);
        contents += '<td class="unit">mm</td>';
        contents += '</tr>\n';
        contents += '<tr>\n';
        contents += '<th><span>壁の歪み補正</span></th>';
        contents += createText(correctionManager.Correction[2]);
        contents += '<td class="unit">mm</td>';
        contents += '</tr>\n';
        contents += '<tr>\n';
        contents += '<th><span>短い壁の削除</span></th>';
        contents += createText(correctionManager.Correction[4]);
        contents += '<td class="unit">mm</td>';
        contents += '</tr>\n';
        contents += '<tr>\n';
        contents += '<th><span>小さい部屋の補正</span></th>';
        contents += createText(correctionManager.Correction[5]);
        contents += '<td class="unit">mm</td>';
        contents += '</tr>\n';
        contents += '<tr>\n';
        contents += '<th><span>交わる壁の頂点の追加</span></th>';
        contents += createText(correctionManager.Correction[8]);
        contents += '<td class="unit">mm</td>';
        contents += '</tr>\n';
        contents += '<tr>\n';
        contents += '<th><span>重なっている独立壁を削除する</span></th>';
        contents += createText(correctionManager.Correction[9]);
        contents += '<td class="unit">mm</td>';
        contents += '</tr>\n';
        contents += '<tr>\n';
        contents += '<th><span>軸平行でない独立壁の削除</span></th>';
        contents += createText(correctionManager.Correction[10]);
        contents += '<td class="unit">度</td>';
        contents += '</tr>\n';
        contents += '<tr>\n';
        contents += '<th><span>なす角が小さい部屋の削除</span></th>';
        contents += createText(correctionManager.Correction[12]);
        contents += '<td class="unit">度</td>';
        contents += '</tr>\n';
        contents += '<tr>\n';
        contents += '<th><span>モジュールピッチ補正【戸建て】</span></th>';
        contents += createSelect(correctionManager.Correction[3]);
        contents += '<td class="unit">グリッド</td>';
        contents += '</tr>\n';
        contents += '<tr>\n';
        contents += '<th><span>モジュールピッチ補正【マンション】</span></th>';
        contents += createSelect(correctionManager.Correction[13]);
        contents += '<td class="unit">グリッド</td>';
        contents += '</tr>\n';
        contents += '</tbody>\n';
        contents += '</table>\n';
        contents += '<tr>\n';
        contents += '<div class="restore_div"><td class="restore_td" colspan="2"><button id="restoreDefault"><span class="jp">初期設定に戻す</span><span class="en">Restore Default</span></button></td></div>\n';
        contents += '</tr>\n';
        contents += '</div>';

        footer = '<button id="btnCancel"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
        footer += '<button id="btnOK"><span class="jp">OK</span><span class="en">OK</span></button>';

        this.createDialog(id, title, contents, footer);

        id = title = contents = footer = null;

        document.querySelector('#CorrectionDialog #restoreDefault')?.addEventListener('click', this.onRestoreDefault);
        document.querySelector('#CorrectionDialog #btnOK')?.addEventListener('click', this.onStartButtonClicked);
        document.querySelector('#CorrectionDialog #btnCancel')?.addEventListener('click', this.close);

        this.addEventInput();        
    }
    
    /**
     * Input更新時にイベント付与
     */
    addEventInput = () => {
        const correctionManager = ThreeView.get().correctionManager;
        const addEvent = (index: number) => {
            const target = this.viewObj.querySelector(`#${correctionManager.Correction[index].key}`);
            target.addEventListener('change', this.onInputChanged);
        }

        addEvent(1);
        addEvent(11);
        addEvent(2);
        addEvent(4);
        addEvent(5);
        addEvent(8);
        addEvent(9);
        addEvent(10);
        addEvent(12);
    }
    
    /**
     * 入力値に制限をかける
     */
    onInputChanged = (e: Event) => {
        const correctionManager = ThreeView.get().correctionManager;

        const limit = (index: number) => {
            let target = Number((<HTMLInputElement>this.viewObj.querySelector(`#${correctionManager.Correction[index].key}`)).value);
            if (target < correctionManager.Correction[index].min) target = correctionManager.Correction[index].min;
            if (correctionManager.Correction[index].max < target) target = correctionManager.Correction[index].max;
            (<HTMLInputElement>this.viewObj.querySelector(`#${correctionManager.Correction[index].key}`)).value = String(target);
        }

        limit(1);
        limit(11);
        limit(2);
        limit(4);
        limit(5);
        limit(8);
        limit(9);
        limit(10);
        limit(12);
    }

    /**
     * 「OK」ボタンがクリックされた
     */
    onStartButtonClicked = () => {
        const correctionManager = ThreeView.get().correctionManager;
        /** 入力値がデフォルトのしきい値と異なる値ならローカルストレージに保存
         * もしくは、入力値がローカルストレージに保存されている内容と異なるなら保存 */
        const save = (key: string, defalt: number) => {
            const value = (<HTMLInputElement>document.getElementById(key)).value;
            const localStrageValue = correctionManager.getLocalStrage(key);
            if (defalt != Number(value)
            || (localStrageValue != null && Number(localStrageValue) != Number(value))) correctionManager.saveLocalStrage(key, Number(value));
        }
        save(correctionManager.Correction[1].key, correctionManager.Correction[1].defalt);
        save(correctionManager.Correction[11].key, correctionManager.Correction[11].defalt);
        save(correctionManager.Correction[2].key, correctionManager.Correction[2].defalt);
        save(correctionManager.Correction[3].key, correctionManager.Correction[3].defalt);
        save(correctionManager.Correction[13].key, correctionManager.Correction[13].defalt);
        save(correctionManager.Correction[4].key, correctionManager.Correction[4].defalt);
        save(correctionManager.Correction[5].key, correctionManager.Correction[5].defalt);
        save(correctionManager.Correction[8].key, correctionManager.Correction[8].defalt);
        save(correctionManager.Correction[9].key, correctionManager.Correction[9].defalt);
        save(correctionManager.Correction[10].key, correctionManager.Correction[10].defalt);
        save(correctionManager.Correction[12].key, correctionManager.Correction[12].defalt);
        this.close();
    }

    /**
     * 「初期設定に戻す」ボタンがクリックされた
     */
    onRestoreDefault = () => {
        const correctionManager = ThreeView.get().correctionManager;
        /** デフォルトの値に戻す */
        (<HTMLInputElement>document.getElementById(correctionManager.Correction[1].key)).value = String(correctionManager.Correction[1].defalt);
        (<HTMLInputElement>document.getElementById(correctionManager.Correction[11].key)).value = String(correctionManager.Correction[11].defalt);
        (<HTMLInputElement>document.getElementById(correctionManager.Correction[2].key)).value = String(correctionManager.Correction[2].defalt);
        (<HTMLSelectElement>document.getElementById(correctionManager.Correction[3].key)).options[1].selected = true;
        (<HTMLSelectElement>document.getElementById(correctionManager.Correction[13].key)).options[2].selected = true;
        (<HTMLInputElement>document.getElementById(correctionManager.Correction[4].key)).value = String(correctionManager.Correction[4].defalt);
        (<HTMLInputElement>document.getElementById(correctionManager.Correction[5].key)).value = String(correctionManager.Correction[5].defalt);
        (<HTMLInputElement>document.getElementById(correctionManager.Correction[8].key)).value = String(correctionManager.Correction[8].defalt);
        (<HTMLInputElement>document.getElementById(correctionManager.Correction[9].key)).value = String(correctionManager.Correction[9].defalt);
        (<HTMLInputElement>document.getElementById(correctionManager.Correction[10].key)).value = String(correctionManager.Correction[10].defalt);
        (<HTMLInputElement>document.getElementById(correctionManager.Correction[12].key)).value = String(correctionManager.Correction[12].defalt);
    }

}